<template>
  <div class="layout">
    <template>
      <div class="layout__header">
        <div class="section">
          <Logo/>
          <div class="header__title">
            Чеки
          </div>
        </div>
      </div>
    </template>
    <div v-if="$slots['main']" class="layout__main">
      <slot name="main"/>
    </div>
    <div class="layout__footer">
      <div class="section">
        {{ buildDate }} | {{ buildVersion }}
      </div>
    </div>
  </div>
</template>

<script>
'use strict'

import Logo from '@/app/components/Logo.vue'

export default {
  name: 'Layout',
  components: {Logo},
  data() {
    return {
      buildDate: process.env.VUE_APP_BUILD,
      buildVersion: process.env.VUE_APP_VERSION
    }
  }
}
</script>
